const POLICY_EXPIRE = 2 * 60 * 1000

type WrappedPolicy<T> = T & { getKey(): string }

export default class PolicyResolver<
	Policy extends { prefix: string } = { prefix: string },
> {
	count = 0

	_fetchFn: () => Promise<Policy>
	_expire: number
	_req: null | Promise<Policy> = null
	_cache: null | { value: WrappedPolicy<Policy>; timestamp: number } = null

	constructor({
		fetchFn,
		expire = POLICY_EXPIRE,
	}: {
		fetchFn: () => Promise<Policy>
		expire?: number
	}) {
		this._fetchFn = fetchFn
		this._expire = expire
	}

	setCache(value: WrappedPolicy<Policy>) {
		this._cache = {
			timestamp: Date.now() + this._expire,
			value,
		}
	}

	getCache() {
		return this._cache && Date.now() < this._cache.timestamp
			? this._cache.value
			: null
	}

	async resolve() {
		return this.getCache() || (await this.fetch())
	}

	async fetch() {
		const data = await this.getNewPolicy()
		const policy = this.getWrappedPolicy(data)

		this.setCache(policy)

		return policy
	}

	getNewPolicy = () => {
		if (this._req) {
			return this._req
		}

		this._req = this._fetchFn()

		return this._req.then((res) => {
			this._req = null
			return res
		})
	}

	getWrappedPolicy(data: Policy): WrappedPolicy<Policy> {
		return {
			...data,
			getKey: () => `${data.prefix}${++this.count}`,
		}
	}
}
